<script setup>
/**
 * A caption in its two beats (picture-caption DESIGN.md): each beat wraps
 * whole, so the break falls between them. Renders inline, inside whatever
 * <p> or <figcaption> holds it.
 */
import { computed } from 'vue'
import { captionBeats } from '@/utils/picture-caption'

const props = defineProps({ text: { type: String, default: '' } })
const beats = computed(() => captionBeats(props.text))
</script>

<template>
  <template v-for="(b, i) in beats" :key="i">{{ i ? ' ' : '' }}<span class="beat">{{ b }}</span></template>
</template>

<style scoped>
.beat { display: inline-block; }
</style>
